import { render, staticRenderFns } from "./ViewVPSoldDetails.vue?vue&type=template&id=d36abc92&"
import script from "./ViewVPSoldDetails.vue?vue&type=script&lang=js&"
export * from "./ViewVPSoldDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports